/**
 * Warehouse text → StockLocation equivalence (request 0111).
 * Logical path: org/{orgId}/warehouse-map
 *
 * Learns supplier/ERP depósito codes so the next invoice resolves automatically.
 * Technical mapping — Auditable only, no Inactivatable.
 */
export const WAREHOUSE_MAP = 'WarehouseMap';
//# sourceMappingURL=warehouse-map.js.map